import React, { useState, useCallback } from 'react';
import { Icon } from 'js/components/common/Icon';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import style from './Action.scss';

export const Action = ({
    title,
    children
}) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = useCallback(() => setExpanded(!expanded), [expanded]);

    return (
        <>
            <AccessibilityElement className={style.transaction} onClick={toggleExpanded}>
                <div className={style.name}>
                    {title}
                </div>
                <div className={style.arrowRow}>
                    <Icon type="bottomListArrow" className={`${style.icon} ${expanded ? style.expanded : ''}`} />
                </div>
            </AccessibilityElement>
            {
                expanded &&
                <div className={style.details}>{children}</div>
            }
        </>
    );
};
